import { BASE_PATHS } from '../constants';

export const getPublicBasePathFromHostname = () => {
    if (typeof window === 'undefined') {
        return BASE_PATHS.TEST;
    }
    const { hostname } = window.location;

    if (hostname.includes('zillow.com')) {
        return BASE_PATHS.PROD;
    }

    return BASE_PATHS.TEST;
};
